import React, { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { getResourceTo } from 'react/utils/utils';
import { isRightOptionsItemSelected } from 'react/api/selectors/header';
import { actionCreators } from 'react/api/actions/header';

import { Flex, Text } from 'onefaceui-react-components';

function RightOptionsItem({
  children,
  title,
  email,
  group,
  name,
  isDsgUser,
  className,
  onClick,
  display,
  totalBadge
}) {
  const dispatch = useDispatch();
  const itIsSelected = useSelector((state) => isRightOptionsItemSelected(state, name));

  const conditionalClassName = useMemo(() => {
    if (children && itIsSelected) {
      return 'dropdown selected';
    }
    if (children) {
      return 'dropdown';
    }
    if (itIsSelected) {
      return 'selected';
    }

    return '';
  }, [name, itIsSelected]);

  const handleOnClick = useCallback(() => {
    if (onClick) {
      onClick(name);

      return;
    }

    dispatch(actionCreators.selectRightOptionsItem(name));
  }, [onClick, name, dispatch]);

  if (!display) {
    return null;
  }

  return (
    <div
      data-testid={`rightOptionsItem-${name}`}
      className={`rightOptionsItem ${className} ${conditionalClassName}`}
    >
      <button
        type="button"
        data-testid={`rightOptionsItem-${name}-button`}
        className="icon"
        onClick={handleOnClick}
        data-badge={totalBadge}
      />
      {!!children && itIsSelected && (
        <div
          data-testid={`dropdownContainer-${name}`}
          className="dropdownContainer"
        >
          {className !== 'headerActivityCenter' && (
            <div className="dropdownHeader">
              <Text weight="medium" className="title" title={getResourceTo(title)}>
                {getResourceTo(title)}
              </Text>
              <Flex gap={6}>
                <Text size="xs" className="email" title={email}>
                  {email}
                </Text>
                {isDsgUser && (
                <Text size="xss" className="emaiTag">
                  SSO
                </Text>
                )}
              </Flex>
              <Text size="xs" className="group" title={group}>
                {group}
              </Text>
            </div>
          )}
          {children}
        </div>
      )}
    </div>
  );
}

RightOptionsItem.defaultProps = {
  children: null,
  title: '',
  email: '',
  group: '',
  className: '',
  onClick: null,
  display: true,
  isDsgUser: false,
  totalBadge: null
};

RightOptionsItem.propTypes = {
  children: PropTypes.element,
  title: PropTypes.string,
  email: PropTypes.string,
  group: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  display: PropTypes.bool,
  isDsgUser: PropTypes.bool,
  totalBadge: PropTypes.number
};

export default memo(RightOptionsItem);
